import { Navigate, Outlet } from "react-router";
import { getLocalStorageItem, clearLocalStorage } from "../utils/Validation";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

const ProtectedRoute = () => {
  const token = getLocalStorageItem("authToken");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!token);

  useEffect(() => {
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    try {
      const decoded: { exp: number } = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decoded.exp < currentTime) {
        clearLocalStorage();
        setIsAuthenticated(false);
      } else {
        // Auto logout when token expires
        const timeout = setTimeout(() => {
          clearLocalStorage();
          setIsAuthenticated(false);
        }, (decoded.exp - currentTime) * 1000);

        return () => clearTimeout(timeout);
      }
    } catch (error) {
      clearLocalStorage();
      setIsAuthenticated(false);
    }
  }, [token]); // ✅ Dependency array ensures effect runs only when token changes

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
